import * as React from "react";
import { Form, Input, Select } from "antd";
import {
  FormTypeFormConstants,
  ReportingTypeTag
} from "../../../common/Constants";

const FormTypeForm = ({
  getFieldDecorator,
  translate,
  rowData
}: {
  getFieldDecorator: any;
  translate: any;
  rowData?: any;
}) => {
  return (
    <Form>
      <Form.Item label={translate("formType_form.code")}>
        {getFieldDecorator(FormTypeFormConstants.Fields.CODE, {
          initialValue: rowData && rowData.code,
          rules: [
            {
              required: true,
              message: translate("formType_form.required_messages", {
                field: translate("formType_form.code")
              })
            }
          ]
        })(
          <Input
            readOnly={rowData ? true : false}
            maxLength={FormTypeFormConstants.VALIDATION_RULES.CODE_MAX_LENGTH}
          ></Input>
        )}
      </Form.Item>
      <Form.Item label={translate("formType_form.name")}>
        {getFieldDecorator(FormTypeFormConstants.Fields.NAME, {
          initialValue: rowData && rowData.name,
          rules: [
            {
              required: true,
              message: translate("formType_form.required_messages", {
                field: translate("formType_form.name")
              })
            }
          ]
        })(
          <Input
            maxLength={FormTypeFormConstants.VALIDATION_RULES.NAME_MAX_LENGTH}
          />
        )}
      </Form.Item>
      <Form.Item label={translate("formType_form.tag")}>
        {getFieldDecorator(FormTypeFormConstants.Fields.TAG, {
          initialValue: rowData && rowData.tag
        })(
          <Select
            placeholder={translate("formType_form.choose_tag")}
            allowClear
            showSearch={true}
            notFoundContent={translate("search.no_data")}
          >
            <Select.Option key={ReportingTypeTag.INITIAL}>
              {translate("formType_form.initial_tag")}
            </Select.Option>
            <Select.Option key={ReportingTypeTag.YEARLY}>
              {translate("formType_form.yearly_tag")}
            </Select.Option>
          </Select>
        )}
      </Form.Item>
    </Form>
  );
};

export default FormTypeForm;
